// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.phoneverification.RentalManagerUserPhoneVerificationWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerUserPhoneVerificationWebApiHandler_isVerified,
  RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Path,
  RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode,
  RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  PhoneVerificationIsVerifiedDto,
  PhoneVerificationSendVerificationCodeDto,
  PhoneVerificationSource,
  PhoneVerificationType,
  PhoneVerificationValidateVerificationCodeDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

interface IsVerifiedParams {
  phone: string;
  verificationSource: PhoneVerificationSource;
}
interface SendVerificationCodeParams {
  phone: string;
  verificationSource: PhoneVerificationSource;
  verificationType: PhoneVerificationType;
}
interface ValidateVerificationCodeParams {
  phone: string;
  verificationCode: string;
  verificationSource: PhoneVerificationSource;
}

export type RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Options = UseQueryOptions<
  PhoneVerificationIsVerifiedDto,
  unknown,
  PhoneVerificationIsVerifiedDto,
  readonly [string, IsVerifiedParams]
>;

const RentalManagerUserPhoneVerificationWebApiHandler_isVerified_GetKey = (getParams: IsVerifiedParams) =>
  [RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Path, getParams] as const;

export const RentalManagerUserPhoneVerificationWebApiHandler_isVerified_queryOptions = (
  getParams: IsVerifiedParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: RentalManagerUserPhoneVerificationWebApiHandler_isVerified_GetKey(getParams),
    queryFn: () => RentalManagerUserPhoneVerificationWebApiHandler_isVerified(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Determine if the phone has been verified for the user
 */
export const useRentalManagerUserPhoneVerificationWebApiHandler_isVerified = (
  getParams: IsVerifiedParams,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...RentalManagerUserPhoneVerificationWebApiHandler_isVerified_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useRentalManagerUserPhoneVerificationWebApiHandler_isVerified.getKey =
  RentalManagerUserPhoneVerificationWebApiHandler_isVerified_GetKey;

export interface RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Args {
  getParams: SendVerificationCodeParams;
}

export type RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Options = UseMutationOptions<
  PhoneVerificationSendVerificationCodeDto,
  unknown,
  RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Args
>;

/**
 * Send a verification code to the provided phone
 */
export const useRentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Args) =>
      RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode(args.getParams, httpClient),
  });
};

export interface RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Args {
  getParams: ValidateVerificationCodeParams;
}

export type RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Options = UseMutationOptions<
  PhoneVerificationValidateVerificationCodeDto,
  unknown,
  RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Args
>;

/**
 * Determine if the verification code is valid for the phone being verified
 */
export const useRentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode = ({
  httpClient,
  ...options
}: Omit<RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Args) =>
      RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode(args.getParams, httpClient),
  });
};
